export const regional_settings = {'currency': "€",'energy_unit': "kWh",'potence_unit': "kW",'amount_unit': "€"}

export const API_SPECIFICATION = 1;
export const API_PREFIX = "/api/v" + API_SPECIFICATION;

export const FETCH_VERSION_REQUEST = 'FETCH_VERSION_REQUEST';
export const RECEIVE_VERSION = 'RECEIVE_VERSION';
export const RECEIVE_VERSION_ERROR = 'RECEIVE_VERSION_ERROR';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGIN_NOT_MADE = 'LOGIN_NOT_MADE';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

export const CLEAR_ERROR = 'CLEAR_ERROR';

export const FETCH_PROTECTED_DATA_REQUEST = 'FETCH_PROTECTED_DATA_REQUEST';
export const RECEIVE_PROTECTED_DATA = 'RECEIVE_PROTECTED_DATA';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const FETCH_SETTINGS_REQUEST = 'FETCH_SETTINGS_REQUEST';
export const RECEIVE_PUBLIC_SETTINGS = 'RECEIVE_PUBLIC_SETTINGS';
export const RECEIVE_PRIVATE_SETTINGS = 'RECEIVE_PRIVATE_SETTINGS';
export const RECEIVE_SETTINGS_ERROR = 'RECEIVE_SETTINGS_ERROR';


export const APP_REMOVE_NODE = 'APP_REMOVE_NODE';
export const APP_TOGGLE_NAME = 'APP_TOGGLE_NAME';
export const APP_UPDATE_PATHS = 'APP_UPDATE_PATHS';
export const APP_CHANGE_OFFSET = 'APP_CHANGE_OFFSET';


export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
export const NOTIFICATION_DONE = 'NOTIFICATION_DONE';
export const SET_MOVE_BATERIA_DONE = 'SET_MOVE_BATERIA_DONE';
export const SET_MOVE_BATERIA_ERROR = 'SET_MOVE_BATERIA_ERROR';
export const SET_MOVE_BATERIA_REQUEST = 'SET_MOVE_BATERIA_REQUEST';

export const FETCH_NEW_CONTRACT_PREFILL_REQUEST = 'FETCH_NEW_CONTRACT_PREFILL_REQUEST';
export const RECEIVE_NEW_CONTRACT_PREFILL = 'RECEIVE_NEW_CONTRACT_PREFILL';

export const RECEIVE_INVOICES = 'RECEIVE_INVOICES';
export const RECEIVE_INVOICES_FILTER = 'RECEIVE_INVOICES_FILTER';
export const RECEIVE_INVOICES_GAS = 'RECEIVE_INVOICES_GAS';
export const RECEIVE_INVOICES_FILTER_GAS = 'RECEIVE_INVOICES_FILTER_GAS';
export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_FILTER_REQUEST = 'FETCH_INVOICES_FILTER_REQUEST';
export const FETCH_INVOICES_REQUEST_GAS = 'FETCH_INVOICES_REQUEST_GAS';
export const FETCH_INVOICES_FILTER_REQUEST_GAS = 'FETCH_INVOICES_FILTER_REQUEST_GAS';
export const EXPORT_INVOICE_REQUEST = 'EXPORT_INVOICE_REQUEST';
export const EXPORT_INVOICE_REQUEST_GAS = 'EXPORT_INVOICE_REQUEST_GAS';
export const RESET_INVOICES = 'RESET_INVOICES';

export const RECEIVE_INVOICES_MULTIPOINT = 'RECEIVE_INVOICES_MULTIPOINT';
export const RECEIVE_INVOICES_MULTIPOINT_FILTER = 'RECEIVE_INVOICES_MULTIPOINT_FILTER';
export const FETCH_INVOICES_MULTIPOINT_REQUEST = 'FETCH_INVOICES_MULTIPOINT_REQUEST';
export const FETCH_INVOICES_MULTIPOINT_FILTER_REQUEST = 'FETCH_INVOICES_MULTIPOINT_FILTER_REQUEST';
export const EXPORT_INVOICE_MULTIPOINT_REQUEST = 'EXPORT_INVOICE_MULTIPOINT_REQUEST';
export const EXPORT_INVOICE_MULTIPOINT_DONE = 'EXPORT_INVOICE_MULTIPOINT_DONE';
export const MESSAGE_INVOICE_MULTIPOINT = 'MESSAGE_INVOICE_MULTIPOINT';

export const EXPORT_INVOICE_DONE = 'EXPORT_INVOICE_DONE';
export const EXPORT_INVOICE_DONE_GAS = 'EXPORT_INVOICE_DONE_GAS';
export const CLEAR_INVOICE_PAGINATION = 'CLEAR_INVOICE_PAGINATION';
export const CLEAR_INVOICE_PAGINATION_GAS = 'CLEAR_INVOICE_PAGINATION_GAS';
export const SET_ITEMS_OFFSET = 'SET_ITEMS_OFFSET';
export const SET_ITEMS_OFFSET_GAS = 'SET_ITEMS_OFFSET_GAS';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_FILTERS_GAS = 'SET_FILTERS_GAS';

export const SET_LEAD_ID = "SET_LEAD_ID";
export const SET_LEAD_STEP_CURRENT = "SET_LEAD_STEP_CURRENT";
export const SET_LEAD_INDEX_COMPLETED = "SET_LEAD_INDEX_COMPLETED";
export const SET_LEAD_ERRORS = "SET_LEAD_ERRORS";
export const SET_LEAD_SUBMIT_REQUEST = "SET_LEAD_SUBMIT_REQUEST";

export const SUBMIT_INSTALLATION_DATA = 'SUBMIT_INSTALLATION_DATA';
export const SUBMIT_PERSON_DATA = 'SUBMIT_PERSON_DATA';
export const SUBMIT_CONTRACT_DATA = 'SUBMIT_CONTRACT_DATA';
export const SET_CONTRACT_ITEMS = 'SET_CONTRACT_ITEMS';
export const SUBMIT_DUAL_GAS_CONTRACT_DATA = 'SUBMIT_DUAL_GAS_CONTRACT_DATA';
export const SUBMIT_PAYMENT_DATA = 'SUBMIT_PAYMENT_DATA';
export const SUBMIT_CONFIRMATION_DATA = 'SUBMIT_CONFIRMATION_DATA';
export const SUBMIT_FINISH = 'SUBMIT_FINISH';
export const SET_PAYING_ITEM_ID = 'SET_PAYING_ITEM_ID';
export const SET_PAYMENT_RELATED_OBJECT_TYPE = 'SET_PAYMENT_RELATED_OBJECT_TYPE';

export const RECEIVE_CONTRACTATION_CONFIG = 'RECEIVE_CONTRACTATION_CONFIG';
export const RECEIVE_DUAL_CONTRACTATION_CONFIG = 'RECEIVE_DUAL_CONTRACTATION_CONFIG';

export const RESET_CONTRACTATION = 'RESET_CONTRACTATION';

export const STORE_SIPS_GAS_DATA = 'STORE_SIPS_GAS_DATA';

export const PERSIST_SIGNUP_DATA = 'PERSIST_SIGNUP_DATA';

export const CREATE_PAYMENT_PLATFORM_REQUEST = "CREATE_PAYMENT_PLATFORM_REQUEST";
export const SET_AVAILABLE_PAYMENT_PLATFORMS = "SET_AVAILABLE_PAYMENT_PLATFORMS";
export const SET_PAYMENT_PLATFORM = "SET_PAYMENT_PLATFORM";
export const SET_PAYMENT_PLATFORM_ERROR = 'SET_PAYMENT_PLATFORM_ERROR';
export const SET_PAYMENT_PLATFORM_SUCCESS = 'SET_PAYMENT_PLATFROM_SUCCESS';
export const CREATE_PAY_REQUEST = 'CREATE_PAY_REQUEST';
export const RESET_PAYMENT_STATUS = "RESET_PAYMENT_STATUS";
export const SET_DOWNLOADING_REPORT = "SET_DOWNLOADING_REPORT";

export const REGISTER_COUPON = 'REGISTER_COUPON';

export const NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST = 'NEW_ELECTRICITY_CONTRACT_CONFIRM_REQUEST';
export const NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE = 'NEW_ELECTRICITY_CONTRACT_CONFIRM_RECEIVE';

/* GAS */
export const SET_GAS_LEAD_ID = 'SET_GAS_LEAD_ID';
export const SET_GAS_LEAD_STEP_CURRENT = "SET_GAS_LEAD_STEP_CURRENT";
export const SET_GAS_LEAD_INDEX_COMPLETED = "SET_GAS_LEAD_INDEX_COMPLETED";
export const SET_GAS_LEAD_ERRORS = "SET_GAS_LEAD_ERRORS";
export const SET_GAS_LEAD_SUBMIT_REQUEST = "SET_GAS_LEAD_SUBMIT_REQUEST";

export const SUBMIT_GAS_INSTALLATION_DATA = 'SUBMIT_GAS_INSTALLATION_DATA';
export const SUBMIT_GAS_PERSON_DATA = 'SUBMIT_GAS_PERSON_DATA';
export const SUBMIT_GAS_CONTRACT_DATA = 'SUBMIT_GAS_CONTRACT_DATA';
export const SUBMIT_GAS_PAYMENT_DATA = 'SUBMIT_GAS_PAYMENT_DATA';
export const SUBMIT_GAS_CONFIRMATION_DATA = 'SUBMIT_GAS_CONFIRMATION_DATA';
export const SUBMIT_GAS_FINISH = 'SUBMIT_GAS_FINISH';

export const RECEIVE_GAS_CONTRACTATION_CONFIG = 'RECEIVE_GAS_CONTRACTATION_CONFIG';

export const RESET_GAS_CONTRACTATION = 'RESET_GAS_CONTRACTATION';

export const SELECT_GAS_PRODUCT = 'SELECT_GAS_PRODUCT';
export const FETCH_AVAILABLE_GAS_PRODUCTS_REQUEST = 'FETCH_AVAILABLE_GAS_PRODUCTS_REQUEST';
export const RECEIVE_AVAILABLE_GAS_PRODUCTS = 'RECEIVE_AVAILABLE_GAS_PRODUCTS';

export const NEW_GAS_CONTRACT_CONFIRM_REQUEST = 'NEW_GAS_CONTRACT_CONFIRM_REQUEST';
export const NEW_GAS_CONTRACT_CONFIRM_RECEIVE = 'NEW_GAS_CONTRACT_CONFIRM_RECEIVE';

/* CRM */

export const FETCH_CONTRACT_LIST = 'FETCH_CONTRACT_LIST';
export const FETCH_CRM_CASE_LIST = 'FETCH_CRM_CASE_LIST';
export const FETCH_CRM_CASE_DETAIL = 'FETCH_CRM_CASE_DETAIL';
export const FETCH_CRM_CASE_SECTIONS = 'FETCH_CRM_CASE_SECTIONS';
export const FETCH_CRM_CASE_CATEGORIES = 'FETCH_CRM_CASE_CATEGORIES';
export const ADD_CRM_CASE_MESSAGE = 'ADD_CRM_CASE_MESSAGE';
export const OPEN_CRM_CASE_MESSAGE = 'OPEN_CRM_CASE_MESSAGE';

/* BANNERS */
export const RECEIVE_BANNERS = 'RECEIVE_BANNERS';
export const FETCH_BANNERS = 'FETCH_BANNERS';
export const SET_BANNERS_ERRORS = 'SET_BANNERS_ERRORS';
export const RECEIVE_BANNERS_CODES = 'RECEIVE_BANNERS_CODES';
export const FETCH_BANNERS_CODES = 'FETCH_BANNERS_CODES';

/* FEATURE FLAGS */
export const FETCH_FEATURE_FLAGS = 'FETCH_FEATURE_FLAGS';
export const FETCH_FEATURE_FLAGS_SUCCESS = 'FETCH_FEATURE_FLAGS_SUCCESS';
export const FETCH_FEATURE_FLAGS_FAILURE = 'FETCH_FEATURE_FLAGS_FAILURE';

/* OMIP */
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_ALERTS = 'FETCH_ALERTS';
export const ADD_ALERT = 'ADD_ALERT';
export const DELETE_ALERT = 'DELETE_ALERT';

/* DOCUMENT REPOSITORY */
export const RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS = 'RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS';
export const RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER = 'RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER';
export const FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST = 'FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST';
export const FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER_REQUEST = 'FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER_REQUEST';
export const EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_REQUEST = 'EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_REQUEST';
export const MESSAGE_DOCUMENT_REPOSITORY_ATTACHMENT = 'MESSAGE_DOCUMENT_REPOSITORY_ATTACHMENT';
export const EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_DONE = 'EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_DONE';
export const CLEAR_DOCUMENT_REPOSITORY_ATTACHMENT_PAGINATION = 'CLEAR_DOCUMENT_REPOSITORY_ATTACHMENT_PAGINATION';
export const EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST = 'EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST';
export const EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_DONE = 'EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_DONE';
export const CLEAR_DOCUMENT_REPOSITORY_ATTACHMENTS_CACHE = 'CLEAR_DOCUMENT_REPOSITORY_ATTACHMENTS_CACHE';

export const colors = [
    '#61A2A5',
    '#D5D5D3',
    '#2E5677',
    '#ffa726',
    '#ff7043',
    '#8d6e63',
    '#bdbdbd',
    '#78909c',
    '#ef5350',
    '#ec407a',
    '#ab47bc',
    '#7e57c2',
    '#5c6bc0',
    '#42a5f5',
    '#29b6f6',
    '#26c6da',
    '#26a69a',
];


export const colors_nova = [
    '#66bb6a',
    '#9ccc65',
    '#d4e157',
    '#ffa726',
    '#ffcc28',
    '#ffee58',
    '#ec407a',
    '#ef5350',
    '#ff7043',
    '#ab47bc',
    '#7e57c2',
    '#5c6bc0',
    '#42a5f5',
    '#29b6f6',
    '#26c6da',
    '#26a69a',
    '#bdbdbd',
    '#78909c',
    '#8d6e63',
];
